import { Link } from "react-router-dom";

export const Logo = ({ testid = "brand-logo-link" }) => (
  <Link to="/" data-testid={testid} className="flex items-center group">
    <img src="/jolgen-wordmark.png" alt="Jolgen Cards" className="logo-intro h-10 sm:h-11 w-auto transition-[filter,transform] duration-500 group-hover:scale-[1.03] group-hover:drop-shadow-[0_0_14px_rgba(138,92,214,.7)]" />
  </Link>
);
